import "./App.css";
import {BrowserRouter} from "react-router-dom";
import Routes from "./router";
import MainLayout from "./layout/main-layout";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import LoginScreen from "./screens/LoginScreen";
import CircularProgress from "@mui/material/CircularProgress"; 
import Box from "@mui/material/Box";
import {useState, useEffect} from "react";

function App() {
    const isAuthenticated = useIsAuthenticated();

    const [showLoader, setShowLoader] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated);
    const { instance } = useMsal();

    const [lastActivity, setLastActivity] = useState(new Date());

    const inactivityTimeout = 15 * 60 * 1000;

    useEffect(() => {
        if (!isAuthenticated) {
            const timer = setTimeout(() => {
                setShowLoader(false);
            }, 3000);

            return () => clearTimeout(timer); 

        } else {
            setShowLoader(false); 
        }
    }, [isAuthenticated]);
    
    useEffect(() => {
        setIsLoggedIn(isAuthenticated); // Sync

        const checkInactivity = setInterval(() => {
            const currentTime = new Date();
            if (currentTime - lastActivity > inactivityTimeout && isLoggedIn) {
                setIsLoggedIn(false);
                handleLogout(); 
                clearInterval(checkInactivity);  
            }
        }, 1000);

        // Reset lastActivity
        const handleUserActivity = () => {
            setLastActivity(new Date());
        };

        // Add event listeners 
        window.addEventListener("mousemove", handleUserActivity);
        window.addEventListener("click", handleUserActivity);
        window.addEventListener("keydown", handleUserActivity);

        //clear interval and remove event listeners
        return () => {
            clearInterval(checkInactivity);
            window.removeEventListener("mousemove", handleUserActivity);
            window.removeEventListener("click", handleUserActivity);
            window.removeEventListener("keydown", handleUserActivity);
        };
    }, [lastActivity, isLoggedIn, isAuthenticated])


    const handleLogout = async () => {
        try {
            //logoutPopup first
            await instance.logoutPopup();
            console.log("User logged out successfully via popup.");
            // optional : redirect to "/" 
            // window.location.href("/");
        } catch (error) {
            console.error("Error during logout with popup: ", error);
            // logoutRedirect if popup fails (e.g., blocked by browser)
            // try {
            //     await instance.logoutRedirect();
            //     console.log("User logged out successfully via redirect.");
            //     //  optional : redirect to "/" 
            //     // window.location.href("/");
            // } catch (redirectError) {
            //     console.error("Error during logout with redirect: ", redirectError);
            // }
        }
    }

    if (showLoader) {
        return (
            <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
                <CircularProgress />
            </Box>
        )
    }


    return (
        <div>
            <BrowserRouter>
                {(isAuthenticated && isLoggedIn) ?
                    <MainLayout >
                        <Routes />
                    </MainLayout>
                :
                    <LoginScreen />
                }
            </BrowserRouter>
        </div>
    );
}

export default App;
